import { render, staticRenderFns } from "./NoticeCenter.vue?vue&type=template&id=12223486&scoped=true"
import script from "./NoticeCenter.vue?vue&type=script&lang=js"
export * from "./NoticeCenter.vue?vue&type=script&lang=js"
import style0 from "./NoticeCenter.vue?vue&type=style&index=0&id=12223486&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12223486",
  null
  
)

export default component.exports